import React, { useState, useEffect, useRef } from 'react';
import SFCustomTable from './custom/SFCustomTable.js';
import { IconButton, Dialog, DialogTitle, DialogContent, DialogActions, TextField, Accordion, AccordionSummary, AccordionDetails } from '@mui/material';
import { MdEdit } from 'react-icons/md';
import { FiTrash2 } from 'react-icons/fi';
import { Button, Cell, Grid } from 'react-md';
import { NotificationManager } from 'react-notifications';
import DeleteDialog from '../pages/DeleteDialog.js';
import { PiCaretDown } from "react-icons/pi";
import { Card } from "react-md";
import HelpText from '../lib/help-text';


const SFHelpTextTable = () => {
    const helpTextRef = useRef(new HelpText());
    const helpText = helpTextRef.current;

    const columns = [
        {
            name: <div className='sf-data-table-header'>No.</div>,
            cell: (row, index) => index + 1,
            sortable: false,
            width: '70px',
        },
        {
            name: <div className='sf-data-table-header'>Field Name</div>,
            selector: row => row.key,
            sortable: true,
            grow: 1,
            wrap: true,
        },
        {
            name: <div className='sf-data-table-header'>Help Text</div>,
            selector: row => row.help_text,
            sortable: true,
            grow: 2,
            wrap: true,
        },
        {
            name: <div className='sf-data-table-header'>Page/Location</div>,
            selector: row => row.page_name,
            sortable: true,
            wrap: true,
        },
        {
            name: <div className='sf-data-table-header'>Actions</div>,
            sortable: false,
            width: '120px',
            cell: (row) => {
                return (
                    <div>
                        <IconButton onClick={() => {
                            setCurrentHelpItem(row);
                            setCreateMode(false);
                            setShowEditDialog(true);
                        }}>
                            <MdEdit color='#576271' />
                        </IconButton>
                        <IconButton onClick={() => {
                            setCurrentHelpItem(row);
                            setShowDeleteDialog(true);
                        }}>
                            <FiTrash2 color='#bb0000' />
                        </IconButton>
                    </div>
                );
            },
        },
    ];

    const [helpTextList, setHelpTextList] = useState([]);
    const [loading, setLoading] = useState(false);
    const [currentHelpItem, setCurrentHelpItem] = useState({ key: '', help_text: '' });
    const [createMode, setCreateMode] = useState(false);
    const [showEditDialog, setShowEditDialog] = useState(false);
    const [showDeleteDialog, setShowDeleteDialog] = useState(false);

    useEffect(() => {
        fetchHelpText();
    }, []);

    const fetchHelpText = () => {
        setLoading(true);
        const getHelpTextPromise = helpText.getAllHelpText(true);

        getHelpTextPromise.then(helpTextMap => {
            setHelpTextList(Object.values(helpTextMap));
        });

        getHelpTextPromise.catch(err => {
            NotificationManager.error(err?.message || String(err), 'ERROR', 3000);
        });

        getHelpTextPromise.finally(() => {
            setLoading(false);
        });
    };

    const handleSave = () => {
        setLoading(true);
        const savePromise = helpText.saveHelpTextItem(currentHelpItem);

        savePromise.then(helpTextMap => {
            setHelpTextList(Object.values(helpTextMap));
            setShowEditDialog(false);
        });

        savePromise.catch(err => {
            NotificationManager.error(err?.message || String(err), 'ERROR', 3000);
        });

        savePromise.finally(() => {
            setLoading(false);
        });
    };

    const handleDelete = () => {
        setLoading(true);
        const deletePromise = helpText.deleteHelpTextItem(currentHelpItem);

        deletePromise.then(helpTextMap => {
            setHelpTextList(Object.values(helpTextMap));
            setShowDeleteDialog(false);
        });

        deletePromise.catch(err => {
            NotificationManager.error(err?.message || String(err), 'ERROR', 3000);
        });

        deletePromise.finally(() => {
            setLoading(false);
        });
    };

    return (
        <div>
            <Card style={{ marginLeft: "0px", marginBottom: '8px',  }}>
                <Accordion sx={{ boxShadow: 'none' }}>
                    <AccordionSummary
                        expandIcon={<PiCaretDown fontSize={24} />}
                    >
                        <div className='semester-title' style={{ display: 'flex', alignItems: 'center' }}>
                            <h3>Help Text ({helpTextList.length})</h3>
                        </div>
                    </AccordionSummary>
                    <AccordionDetails>
                        <SFCustomTable
                            loading={loading}
                            columns={columns}
                            selectableRows={false}
                            data={helpTextList}
                            topPagination={false}
                            bottomPagination={true}
                            showSearch={true}
                            searchPlaceholder="Search by field name"
                            searchByFields={['key']}
                            rowsPerPage={20}
                            btn={
                                <Button style={{ marginLeft: '8px' }} primary raised onClick={() => {
                                    setCurrentHelpItem({ key: '', help_text: '' });
                                    setCreateMode(true);
                                    setShowEditDialog(true);
                                }}>
                                    Add New Help Text
                                </Button>
                            }
                        />
                    </AccordionDetails>
                </Accordion>
            </Card>

            {/* Add/Edit dialog */}
            <Dialog open={showEditDialog} maxWidth="sm" fullWidth>
                <DialogTitle>
                    {createMode ? 'Add Help Text' : 'Edit Help Text'}
                </DialogTitle>
                <DialogContent>
                    <TextField
                        fullWidth
                        label="Field Name"
                        placeholder="Enter the name of the Field you want to add Help content here..."
                        id="key-id"
                        value={currentHelpItem.key}
                        onChange={event => {
                            setCurrentHelpItem({ ...currentHelpItem, key: event.target.value });
                        }}
                        disabled={!createMode}
                        required
                        style={{ marginBottom: '16px', marginTop: '8px' }}
                    />
                    <TextField
                        fullWidth
                        label="Help Text"
                        placeholder="Enter the Help content for the Field here..."
                        id="help-text-id"
                        value={currentHelpItem.help_text}
                        onChange={event => {
                            setCurrentHelpItem({ ...currentHelpItem, help_text: event.target.value });
                        }}
                        multiline
                        rows={3}
                    />
                    <TextField
                        style={{ marginTop: '16px',}}
                        fullWidth
                        label="Page/Location Name"
                        placeholder="Enter the page or location name"
                        id="help-text-page-name"
                        value={currentHelpItem.page_name}
                        inputProps={{ maxLength: 200 }}
                        onChange={event => {
                            setCurrentHelpItem({ ...currentHelpItem, page_name: event.target.value });
                        }}
                    />
                </DialogContent>
                <DialogActions>
                    <Button primary flat onClick={() => setShowEditDialog(false)}>
                        Cancel
                    </Button>
                    <Button primary raised onClick={handleSave}>
                        Save
                    </Button>
                </DialogActions>
            </Dialog>

            {/* Delete dialog */}
            <DeleteDialog
                showDialog={showDeleteDialog}
                title={"Delete Help Text"}
                description={`Are you sure you want to delete help text for "${currentHelpItem.key}"?`}
                onCancel={() => {
                    setCurrentHelpItem({ key: '', help_text: '' });
                    setShowDeleteDialog(false);
                }}
                onDelete={() => {
                    handleDelete();
                }}
            />
        </div>
    );
};

export default SFHelpTextTable;
